const DISCLOSURE_OPTIONS = [
  {text: '非公開', html: '非公開', value: 0},
  {text: '公開（集計数のみ）', html: '公開<span class="small">（集計数のみ）</span>', value: 1},
  {text: '公開（全て）', html: '公開<span class="small">（全て）</span>', value: 2},
]

export default DISCLOSURE_OPTIONS